import { MdAutoAwesome } from "react-icons/md";
import { Link } from "react-router-dom";

const FreeCard = () => {
  return (
    <div className="relative mt-14 flex w-[256px] justify-center rounded-[20px] bg-gradient-to-br from-purple-500 via-brand-500 to-brand-600 pb-4 shadow-xl shadow-brand-500/20">
      <div className="absolute -top-12 flex h-24 w-24 items-center justify-center rounded-full border-[4px] border-white bg-gradient-to-b from-purple-400 to-brand-500 shadow-sm dark:!border-navy-800">
        <MdAutoAwesome className="h-10 w-10 text-white" />
      </div>

      <div className="mt-16 flex h-fit flex-col items-center">
        <p className="text-lg font-bold text-white">Chat with AI</p>
        <p className="mt-1 px-4 text-center text-sm text-white/80">
          Ask questions, generate overviews, or brainstorm ideas with our AI.
        </p>

        <Link
          to="/admin/chat"
          className="text-medium mt-7 block rounded-full bg-white py-[12px] px-11 text-center text-base font-bold text-brand-500 hover:bg-gray-50 hover:shadow-lg transition-all"
        >
          Open Chat
        </Link>
      </div>
    </div>
  );
};

export default FreeCard;
